/**
 * @generated SignedSource<<b83f28e1481ddab674d916893c028e42>>
 * @relayHash 1f09213993754544aa08c52be2fc631e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006

import type { ConcreteRequest } from 'relay-runtime';
export type PromptPopupPaywallContentToDisableQuery$variables = Record<PropertyKey, never>;
export type PromptPopupPaywallContentToDisableQuery$data = {
  readonly paywallContentToDisable: {
    readonly deactivationIdentifier: string;
    readonly link: string | null;
    readonly title: string | null;
  } | null;
};
export type PromptPopupPaywallContentToDisableQuery = {
  response: PromptPopupPaywallContentToDisableQuery$data;
  variables: PromptPopupPaywallContentToDisableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "contentType",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaywallContentSingle",
    "kind": "LinkedField",
    "name": "paywallContentToDisable",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "deactivationIdentifier"
      },
      {
        "kind": "ScalarField",
        "name": "link"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ],
    "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PromptPopupPaywallContentToDisableQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PromptPopupPaywallContentToDisableQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1f09213993754544aa08c52be2fc631e",
    "id": "ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006",
    "metadata": {},
    "name": "PromptPopupPaywallContentToDisableQuery",
    "operationKind": "query",
    "text": "query PromptPopupPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
  }
};
})();

(node as any).hash = "bb7d0d4a20298d54ac0ea3dd0fe0a1fe";

export default node;
